function initCollapsibleText() {
    $('.collapsible-text').click(function () {
        $(this).toggleClass('collapsible-text-open');
    });
}